import { useEffect } from 'react';
import { MantineProvider } from '@mantine/core';
import { ContestStatus } from '@betterpool/api-types/contests-service';

import { reportEvent } from '~/domains/analytics';
import { ContestDetailPage } from '~/domains/contest/domains/detail/pages/ContestDetailPage/ContestDetailPage';
import { PageLayout } from '~/domains/common/app/PageLayout';

import {
  ContestContextProvider,
  useContestContext,
} from '../domains/common/context/ContestContext/ContestContext';
import GamecenterPageLoadingStatesHandler from '../domains/common/components/GamecenterPageLoadingStatesHandler/GamecenterPageLoadingStatesHandler';
import GamecenterNonScheduledLayout from '../domains/common/components/GamecenterNonScheduledLayout/GamecenterNonScheduledLayout';
import { useIsGamecenterEnabled } from '../domains/common/hooks/useIsGamecenterEnabled';
import ContestDetail from '../../detail/components/ContestDetail/ContestDetail';
import useIsGamecenterScreenSupportedOnNativeAppsOnly from '../domains/common/hooks/useIsGamecenterScreenSupportedOnNativeAppsOnly';
import GamecenterScheduledLayout from '../domains/common/components/GamecenterScheduledLayout/GamecenterScheduledLayout';

function DetailPageContent() {
  const { contest } = useContestContext();
  const { isSettled, isEnabled } = useIsGamecenterEnabled(
    contest?.contest_type,
    contest?.league.sport
  );
  const { isSupported: isAllScreensSupportedOnNativeAppsOnly } =
    useIsGamecenterScreenSupportedOnNativeAppsOnly({
      contest,
    });

  if (!isSettled) {
    return null;
  }

  if (!isEnabled || !contest?.entries.user || isAllScreensSupportedOnNativeAppsOnly) {
    return (
      <PageLayout hasAppBanners>
        <ContestDetailPage />
      </PageLayout>
    );
  }

  if (contest?.status === ContestStatus.SCHEDULED) {
    return (
      <GamecenterScheduledLayout chatLayoutMode="anchored-left">
        <ContestDetail hideEntries hideCTA />
      </GamecenterScheduledLayout>
    );
  }

  return (
    <GamecenterNonScheduledLayout chatLayoutMode="anchored-left">
      <ContestDetail hideEntries hideCTA />
    </GamecenterNonScheduledLayout>
  );
}

function GamecenterDetailPage() {
  return (
    <MantineProvider withNormalizeCSS withGlobalStyles inherit theme={{ colorScheme: 'light' }}>
      <ContestContextProvider>
        <GamecenterPageLoadingStatesHandler>
          <DetailPageContent />
        </GamecenterPageLoadingStatesHandler>
      </ContestContextProvider>
    </MantineProvider>
  );
}

export default GamecenterDetailPage;
